import React, {useCallback} from 'react';

import {Explanation, SampleResponse} from '../shared/ContentBlocks';
import type {QuestionComponentProps} from '../shared/QuestionComponent/QuestionComponent.react';
import {QuestionComponent} from '../shared/QuestionComponent/QuestionComponent.react';

import CompletenessBanner from './CompletenessBanner';
import IncompletenessBanner from './IncompletenessBanner';
import ErrorBoundary from './WrittenSubmission/ErrorBoundary';
import WrittenSubmission from './WrittenSubmission/WrittenSubmission.react';

const FreeResponseQuestionComponent = (props: QuestionComponentProps) => {
  const {activeQuestion, activeQuestionStore, guess, questionState} = props;
  const storeName = activeQuestionStore?.getName();
  const InputFragment = useCallback(() => {
    let writtenSubmissionFragment: React.ReactNode = null;
    if (questionState === 'PreGuess') {
      writtenSubmissionFragment = (
        <WrittenSubmission
          storeName={storeName}
          question={activeQuestion}
          submitted={!!guess?.getId()}
        />
      );
    } else if (guess?.getId()) {
      writtenSubmissionFragment = (
        <>
          <CompletenessBanner />
          <WrittenSubmission storeName={storeName} question={activeQuestion} submitted />
        </>
      );
    } else if (!guess?.getId()) {
      writtenSubmissionFragment = <IncompletenessBanner />;
    }

    return questionState !== 'Dennis' ? (
      <ErrorBoundary>{writtenSubmissionFragment}</ErrorBoundary>
    ) : null;
  }, [activeQuestion, storeName, guess, questionState]);

  const customExplanation = (
    <>
      <SampleResponse question={activeQuestion} />
      <Explanation question={activeQuestion} />
    </>
  );

  return (
    <QuestionComponent
      {...props}
      customExplanation={customExplanation}
      customHOA={<></>}
      customResultIndicator={<></>}
      ActiveQuestionInputArea={InputFragment}
    />
  );
};

type FreeResponseQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const FreeResponseQuestion = {
  PreGuess: (props: FreeResponseQuestionTypeProps) => (
    <FreeResponseQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: FreeResponseQuestionTypeProps) => (
    <FreeResponseQuestionComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: FreeResponseQuestionTypeProps) => (
    <FreeResponseQuestionComponent {...props} questionState='Dennis' />
  )
};

export {FreeResponseQuestion};
